export default {
  VUE: '//s1.e.vhall.com/common-static/middle/vue/2.6.14/dist/vue.min.js',
  ELEMENTCSS: '//s3.e.vhall.com/common-static/middle/element-ui/lib/2.6.2/theme-chalk/index.css',
  ELEMENTJS: '//s2.e.vhall.com/common-static/middle/element-ui/lib/2.6.2/index.js',
  VHALLJS: '//cnstatic01.e.vhall.com/common-static/middle/vhall-ui/v2.0.2/index.js',
  // VHALLCSS: '//cnstatic01.e.vhall.com/common-static/middle/vhall-ui/v2.0.2-beta/index.css',
  VHALLCSS: '//cnstatic01.e.vhall.com/common-static/middle/vhall-ui/v2.0.2/index.css',

  CAPTCHAJS: '//turing.captcha.qcloud.com/TJCaptcha.js',
  // VANTCSS: 'https://cdn.jsdelivr.net/npm/vant@2.1/lib/index.css',
  // VANTJS: 'https://cdn.jsdelivr.net/npm/vant@2.1/lib/vant.min.js'
}
